export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="relative bg-[#FF5C00] text-white overflow-hidden">
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 mb-8 sm:mb-10">
          <div>
            <img
              src="https://static.wixstatic.com/media/288b4c_cdd9acebf50e495592734f144fbf4ac7~mv2.png/v1/fill/w_81,h_32,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/288b4c_cdd9acebf50e495592734f144fbf4ac7~mv2.png"
              alt="Renoboys logo"
              className="h-10 sm:h-12 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-sm sm:text-base text-white/90 leading-relaxed">
              Quality you can see. Renovations you can trust.
            </p>
          </div>

          <div>
            <h3 className="text-base sm:text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2.5 sm:space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('home')}
                  className="text-sm sm:text-base text-white/90 hover:text-white transition-colors cursor-pointer"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-sm sm:text-base text-white/90 hover:text-white transition-colors cursor-pointer"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('portfolio')}
                  className="text-sm sm:text-base text-white/90 hover:text-white transition-colors cursor-pointer"
                >
                  Portfolio
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-sm sm:text-base text-white/90 hover:text-white transition-colors cursor-pointer"
                >
                  About
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-base sm:text-lg font-semibold mb-4">Contact</h3>
            <ul className="space-y-2.5 sm:space-y-3">
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-base sm:text-lg mt-0.5 flex-shrink-0"></i>
                <a
                  href="tel:021 086 21239"
                  className="text-sm sm:text-base text-white/90 hover:text-white transition-colors cursor-pointer"
                >
                  021 086 21239
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-base sm:text-lg mt-0.5 flex-shrink-0"></i>
                <a
                  href="mailto:info@renoboys.co.nz"
                  className="text-sm sm:text-base text-white/90 hover:text-white transition-colors cursor-pointer break-all"
                >
                  info@renoboys.co.nz
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-base sm:text-lg mt-0.5 flex-shrink-0"></i>
                <span className="text-sm sm:text-base text-white/90">Kingsland, Auckland</span>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-base sm:text-lg font-semibold mb-4">Service Areas</h3>
            <p className="text-sm sm:text-base text-white/90 leading-relaxed">
              Proudly servicing all Auckland regions including Central Auckland, North Shore, West Auckland, South Auckland, and East Auckland.
            </p>
          </div>
        </div>

        <div className="border-t border-white/20 pt-6 sm:pt-8 text-center">
          <p className="text-xs sm:text-sm text-white/80">
            © 2025 RENO BOYS. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}